import {guestCardTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = guestCardTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const guestCardReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default guestCardReducer;
